<template>
  <div class="latest-news-fi">
    <teaser-tile-fi
      v-for="(news, index) in latestPressNews"
      :key="index"
      :fields="news"
      theme="newsroom"
    />

    {{ getRestructuredData }}
  </div>
</template>

<script>
import axios from 'axios';
import { defineAsyncComponent } from 'vue';

const TeaserTileFi = defineAsyncComponent(() => import('pages/teaser-tile-fi/TeaserTileFi'));

export default {
  name: 'LatestNewsFi',
  components: {
    TeaserTileFi,
  },
  data() {
    return {
      latestPressNews: [],
    };
  },
  serverPrefetch() {
    this.getPressNews();
  },
  mounted() {
    this.getPressNews();
  },
  methods: {
    async getPressNews() {
      const pressReleasesUrl = IS_SHOWROOM
        ? '/__mocks__/newsroom/newsroom-overview.json'
        : `${this.$fischer.hostUrlBase()}/api/press/get?lang=${this.$fischer.siteLanguage()}&pagesize=3`;

      const { data: pressResult } = await axios.get(pressReleasesUrl);

      const getLocalDate = (date) =>
        date
          ? new Date(date).toLocaleDateString(this.$fischer.siteLanguage(), {
              day: '2-digit',
              month: '2-digit',
              year: 'numeric',
            })
          : '';

      this.latestPressNews = pressResult?.Data?.PressReleasesList?.map((n) => ({
        headline: { value: n.Document.TeaserHeadline },
        date: { value: getLocalDate(n.Document.Date) },
        paragraph: { value: n.Document.TeaserText },
        image: {
          value: {
            src: n.Document.TeaserImage,
          },
        },
        link: {
          value: {
            href: n.Document.ItemLink,
            url: n.Document.ItemLink,
          },
        },
        lang: { value: n.Document.Language },
      }));
    },
  },
};
</script>

<style scoped lang="scss">
@import './latest-news-fi';
</style>
